export default {
  AF: 'Afghanistan',
  AX: 'Ålandinseln',
  AL: 'Albanien',
  DZ: 'Algerien',
  AS: 'Amerikanisch-Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarktis',
  AG: 'Antigua und Barbuda',
  AR: 'Argentinien',
  AM: 'Armenien',
  AW: 'Aruba',
  AU: 'Australien',
  AT: 'Österreich',
  AZ: 'Aserbaidschan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesch',
  BE: 'Belgien',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivien',
  BA: 'Bosnien und Herzegowina',
  BW: 'Botsuana',
  BV: 'Bouvetinsel',
  BR: 'Brasilien',
  IO: 'Britisches Territorium im Indischen Ozean',
  BN: 'Brunei',
  BG: 'Bulgarien',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Kambodscha',
  CM: 'Kamerun',
  CA: 'Kanada',
  CV: 'Kap Verde',
  KY: 'Kaimaninseln',
  CF: 'Zentralafrikanische Republik',
  TD: 'Tschad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Weihnachtsinsel',
  CC: 'Kokosinseln',
  CO: 'Kolumbien',
  KM: 'Komoren',
  CG: 'Kongo',
  CD: 'Demokratische Republik Kongo',
  CK: 'Cookinseln',
  CR: 'Costa Rica',
  CI: 'Elfenbeinküste',
  HR: 'Kroatien',
  CU: 'Kuba',
  CY: 'Zypern',
  CZ: 'Tschechische Republik',
  DK: 'Dänemark',
  DJ: 'Dschibuti',
  DM: 'Dominica',
  DO: 'Dominikanische Republik',
  EC: 'Ecuador',
  EG: 'Ägypten',
  SV: 'El Salvador',
  GQ: 'Äquatorialguinea',
  ER: 'Eritrea',
  EE: 'Estland',
  ET: 'Äthiopien',
  FK: 'Falklandinseln',
  FO: 'Färöer-Inseln',
  FJ: 'Fidschi',
  FI: 'Finnland',
  FR: 'Frankreich',
  GF: 'Französisch-Guayana',
  PF: 'Französisch-Polynesien',
  TF: 'Französische Süd- und Antarktisgebiete',
  GA: 'Gabun',
  GM: 'Gambia',
  GE: 'Georgien',
  DE: 'Deutschland',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Griechenland',
  GL: 'Grönland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard und McDonaldinseln',
  VA: 'Heiliger Stuhl (Vatikanstadt)',
  HN: 'Honduras',
  HK: 'Hongkong',
  HU: 'Ungarn',
  IS: 'Island',
  IN: 'Indien',
  ID: 'Indonesien',
  IR: 'Iran',
  IQ: 'Irak',
  IE: 'Irland',
  IM: 'Isle of Man',
  IL: 'Israel',
  IT: 'Italien',
  JM: 'Jamaika',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordanien',
  KZ: 'Kasachstan',
  KE: 'Kenia',
  KI: 'Kiribati',
  KP: 'Nordkorea',
  KR: 'Südkorea',
  KW: 'Kuwait',
  KG: 'Kirgisistan',
  LA: 'Laos',
  LV: 'Lettland',
  LB: 'Libanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libyen',
  LI: 'Liechtenstein',
  LT: 'Litauen',
  LU: 'Luxemburg',
  MO: 'Macao',
  MK: 'Nordmazedonien',
  MG: 'Madagaskar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Malediven',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshallinseln',
  MQ: 'Martinique',
  MR: 'Mauretanien',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexiko',
  FM: 'Mikronesien',
  MD: 'Moldawien',
  MC: 'Monaco',
  MN: 'Mongolei',
  MS: 'Montserrat',
  MA: 'Marokko',
  MZ: 'Mosambik',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Niederlande',
  AN: 'Niederländische Antillen',
  NC: 'Neukaledonien',
  NZ: 'Neuseeland',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolkinsel',
  MP: 'Nördliche Marianen',
  NO: 'Norwegen',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palästinensische Gebiete',
  PA: 'Panama',
  PG: 'Papua-Neuguinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippinen',
  PN: 'Pitcairninseln',
  PL: 'Polen',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Katar',
  RE: 'Réunion',
  RO: 'Rumänien',
  RU: 'Russland',
  RW: 'Ruanda',
  SH: 'St. Helena',
  KN: 'St. Kitts und Nevis',
  LC: 'St. Lucia',
  PM: 'St. Pierre und Miquelon',
  VC: 'St. Vincent und die Grenadinen',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'São Tomé und Príncipe',
  SA: 'Saudi-Arabien',
  SN: 'Senegal',
  CS: 'Serbien und Montenegro',
  SC: 'Seychellen',
  SL: 'Sierra Leone',
  SG: 'Singapur',
  SK: 'Slowakei',
  SI: 'Slowenien',
  SB: 'Salomonen',
  SO: 'Somalia',
  ZA: 'Südafrika',
  GS: 'Südgeorgien und die Südlichen Sandwichinseln',
  ES: 'Spanien',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SJ: 'Svalbard und Jan Mayen',
  SZ: 'Eswatini',
  SE: 'Schweden',
  CH: 'Schweiz',
  SY: 'Syrien',
  TW: 'Taiwan',
  TJ: 'Tadschikistan',
  TZ: 'Tansania',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad und Tobago',
  TN: 'Tunesien',
  TR: 'Türkei',
  TM: 'Turkmenistan',
  TC: 'Turks- und Caicosinseln',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'Vereinigte Arabische Emirate',
  GB: 'Vereinigtes Königreich',
  US: 'Vereinigte Staaten',
  UM: 'Kleinere Amerikanische Überseeinseln',
  UY: 'Uruguay',
  UZ: 'Usbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela',
  VN: 'Vietnam',
  VG: 'Britische Jungferninseln',
  VI: 'Amerikanische Jungferninseln',
  WF: 'Wallis und Futuna',
  EH: 'Westsahara',
  YE: 'Jemen',
  ZM: 'Sambia',
  ZW: 'Simbabwe',
};
